import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { APP_STORE_URLS } from 'shared/constants/externalUrls';
import { getAppStoreAppUrl } from 'shared/utils/externalUrls';

import { InvoiceIcon } from '@/assets/svg';
import { AppPromotion, ExternalLink } from '@/components';
import { useRegion } from '@/hooks/useRegion';
import { COLOR, ENTITY_COLOR_TRANSPARENT_40 } from '@/theme/colors';

export function InvoicingNotAvailableSection() {
    const { t } = useTranslation();

    const userRegion = useRegion();

    const appStoreUrl = userRegion?.code
        ? getAppStoreAppUrl(userRegion.code)
        : APP_STORE_URLS.APPLE;

    return (
        <Box className="flex items-center justify-center gap-16 h-full min-w-[360px]">
            <Box className="flex flex-col items-center w-[312px] pb-[20px]">
                <InvoiceIcon
                    color={ENTITY_COLOR_TRANSPARENT_40.invoices}
                    height={200}
                    width={150}
                />
                <Box className="mb-[12px] mt-[-20px] flex justify-center">
                    <Typography
                        sx={{
                            fontSize: 22,
                            fontWeight: 700,
                            textAlign: 'center',
                            width: 240,
                        }}
                    >
                        {t('InvoiceSystem:web_coming_soon:title')}
                    </Typography>
                </Box>
                <Box className="p-[14px] bg-alabaster rounded-[8px]">
                    <Typography
                        sx={{
                            fontSize: 11,
                            color: COLOR.nevada,
                        }}
                    >
                        {t('InvoiceSystem:web_coming_soon:description')}{' '}
                        <ExternalLink href={appStoreUrl}>iOS</ExternalLink>{' '}
                        {t('Generic:or')}{' '}
                        <ExternalLink href={APP_STORE_URLS.GOOGLE_PLAY}>
                            Android
                        </ExternalLink>
                        .
                    </Typography>
                </Box>
            </Box>
            <AppPromotion />
        </Box>
    );
}
